import React, { useState } from "react";
import { useQuery } from "react-query";
import { useSelector } from "react-redux";

import Fetching from "@/components/Fetching/Fetching";
import { decimalFormatOptions, localString } from "@/components/global.constants";
import { getDashboardExpiration } from "@/api/Dashboard/dashboard";
import { validRoles } from "@/services/Utils";
import DashboardExpirationTable from "./DashboardExpirationTable";

import classes from "./dashboard-expiration.module.scss";

const DashboardExpiration = ({ filters }) => {
	const userRoles = JSON.parse(localStorage.getItem("roles"));
	const isManager = validRoles(userRoles, ["administrador", "gerente_agricola"]);

	const { estate_parent_id, estate_id, type_currency } = useSelector((state) => state.auth.filter);

	const [type, setType] = useState("quantity");
	const [show, setShow] = useState(false);
	const [index, setIndex] = useState(0);

	const { data, isLoading } = useQuery(["dashboard_expiration", { ...filters, type, estate_parent_id, estate_id, type_currency }], () =>
		getDashboardExpiration({ ...filters, type, estate_parent_id, estate_id, type_currency }),
	);

	let total = 0;
	if (data) {
		data.forEach((item) => {
			total += item.quantity;
		});
	}

	return (
		<>
			{isLoading ? (
				<Fetching topMargin="5em" bottomMargin="5em" />
			) : (
				<>
					{isManager && (
						<div className={classes.filter}>
							<div className={classes.filter_type}>
								<div className={`${classes.type_quantity} ${type === "quantity" && classes.active}`} onClick={() => setType("quantity")}>
									Cantidad
								</div>
								<div className={`${classes.type_price} ${type === "price" && classes.active}`} onClick={() => setType("price")}>
									Precio
								</div>
							</div>
						</div>
					)}

					<div className={classes.expiration}>
						{data &&
							data.map((value, i) => {
								return (
									<React.Fragment key={i}>
										<div className={classes.expiration_div}>
											<div className={classes.expiration_text}>{value.text}</div>
											<div
												className={classes.expiration_quantity}
												style={{
													color: value.color,
												}}
											>
												{`${type === "price" ? "$" : ""}${value.quantity.toLocaleString(localString, decimalFormatOptions)}`}
											</div>
											<div className={classes.expiration_percentage}>
												{(total === 0 ? 0 : (value.quantity / total) * 100).toLocaleString(localString, decimalFormatOptions)}%
											</div>
										</div>
										<div className={classes.expiration_bar}>
											<div
												style={{
													cursor: "pointer",
													height: "100%",
													borderRadius: "10px",
													width: `${total === 0 ? 0 : (value.quantity / total) * 100}%`,
													backgroundColor: value.color,
												}}
												onClick={() => {
													setIndex(i);
													setShow(true);
												}}
											></div>
										</div>
									</React.Fragment>
								);
							})}
					</div>
				</>
			)}

			<DashboardExpirationTable index={index} show={show} setShow={setShow} />
		</>
	);
};

export default DashboardExpiration;
